import { getStoredToken } from './auth'
import type { DepositLoan } from './depositLoan.types'

const API_BASE_URL = import.meta.env.VITE_DAPI_URL || ''

// Carries the HTTP status so callers can distinguish a 404 (loan is not active)
// from other failures and render a graceful "not active" state.
export class DepositLoanRequestError extends Error {
  status: number

  constructor(message: string, status: number) {
    super(message)
    this.name = 'DepositLoanRequestError'
    this.status = status
  }
}

const getAuthorizationHeader = () => {
  const token = getStoredToken()

  if (!token || !('jwt' in token) || !token.jwt) {
    throw new DepositLoanRequestError('Missing authentication token.', 401)
  }

  return { authorization: `bearer ${token.jwt}` }
}

export const fetchDepositLoanById = async (id: string): Promise<DepositLoan> => {
  const response = await fetch(`${API_BASE_URL}/borgo/distributor/deposit-loans/${encodeURIComponent(id)}`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'content-type': 'application/json',
      ...getAuthorizationHeader(),
    },
  })

  if (!response.ok) {
    throw new DepositLoanRequestError(
      `Kunde inte hämta handpenningslån med id ${id}`,
      response.status,
    )
  }

  return await response.json()
}
